export const SIGN_OUT = 'singOut/SING_OUT';
